import { render, staticRenderFns } from "./SuccessPassword.vue?vue&type=template&id=5243f616&"
import script from "./SuccessPassword.vue?vue&type=script&lang=js&"
export * from "./SuccessPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports